import { motion } from "motion/react";
import { type ReactNode } from "react";

export function WithSearchFocus({
  hasFocus,
  children,
}: {
  children: NonNullable<ReactNode>;
  hasFocus: boolean;
}) {
  return (
    <div className="relative flex h-20 w-full min-w-0 items-center rounded-full px-8 text-left">
      <div className="absolute inset-0 z-20 flex items-center">
        <div className="w-full px-4 md:px-6">{children}</div>
      </div>
      {hasFocus ? (
        <motion.div
          className="shadow-card-sm pointer-events-none absolute inset-0 z-10 rounded-full bg-white"
          layoutId="searchFocus"
        ></motion.div>
      ) : null}
    </div>
  );
}
